import { IDictionaryMarket } from '@/creditflowresearch/domain/vo/IDictionary';
import Market from './Market';
import UsMarket from './entities/UsMarket';
import EuropeanMarket from './entities/EuropeanMarket';
import ApacMarket from './entities/ApacMarket';
import EmergingMarket from './entities/EmergingMarket';
import { MarketAbbreviations } from '@/creditflowresearch/domain/Market/types/MarketType';

type MarketConstructor = {
  new (data: IDictionaryMarket, abbreviation: MarketAbbreviations): Market,
  ABBREVIATION: MarketAbbreviations,
};

class MarketFactory {
  private static readonly entityClassMap = new Map<string, MarketConstructor>([
    [UsMarket.MARKET_ID, UsMarket],
    [EuropeanMarket.MARKET_ID, EuropeanMarket],
    [ApacMarket.MARKET_ID, ApacMarket],
    [EmergingMarket.MARKET_ID, EmergingMarket],
  ]);

  static createFromData(data: IDictionaryMarket): Market | null {
    const EntityClass = MarketFactory.entityClassMap.get(data.id);

    if (!EntityClass) {
      return null;
    }

    return new EntityClass(data, EntityClass.ABBREVIATION);
  }
}

export default MarketFactory;
